import React from 'react';

export interface PersistentDashboardOptions {
  title?: React.ReactNode;
  padding?: string;
}

interface PersistentDashboardContextValue {
  registerOptions: (options: PersistentDashboardOptions) => void;
}

const PersistentDashboardContext =
  React.createContext<PersistentDashboardContextValue | null>(null);

export default PersistentDashboardContext;
